export default "__VITE_ASSET__BopuElqi__"